import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getSenderDetailsRequest = {};
var _getSenderDetailsResponse = { senderDetails: '_senderDetails' };
var _resolveActualFromAddressRequest = {};
var _resolveActualFromAddressResponse = {};
var _senderDetails = { dateVerified: 'google.protobuf.Timestamp' };
var _updateSenderDetailsRequest = { senderDetails: '_senderDetails' };
var _updateSenderDetailsResponse = {};
var _verifySenderEmailRequest = {};
var _verifySenderEmailResponse = {};
function resolveWixEmailmarketingApiV1SenderDetailsServiceUrl(opts) {
    var domainToMappings = {
        'editor._base_domain_': [
            {
                srcPath: '/shoutout',
                destPath: '',
            },
            {
                srcPath: '/_api/shoutout-editor',
                destPath: '/api',
            },
            {
                srcPath: '/_api/shoutout/v1',
                destPath: '/v1',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/shoutout',
                destPath: '',
            },
            {
                srcPath: '/_api/shoutout-editor',
                destPath: '/api',
            },
            {
                srcPath: '/_api/shoutout/v1',
                destPath: '/v1',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/shoutout',
                destPath: '',
            },
            {
                srcPath: '/_api/shoutout-editor',
                destPath: '/api',
            },
            {
                srcPath: '/_api/shoutout/v1',
                destPath: '/v1',
            },
        ],
        'shoutout._base_domain_': [
            {
                srcPath: '/_api/shoutout-editor',
                destPath: '/api',
            },
            {
                srcPath: '/_api/shoutout/v1',
                destPath: '/v1',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/shoutout-editor',
                destPath: '/api',
            },
            {
                srcPath: '/_api/shoutout/v1',
                destPath: '/v1',
            },
        ],
        'shoutouteditor._base_domain_': [
            {
                srcPath: '/_api/shoutout-editor',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/shoutout-editor',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/shoutout/v1',
                destPath: '/v1',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/_api/shoutout/v1',
                destPath: '/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/shoutout-editor',
                destPath: '/api',
            },
            {
                srcPath: '/_api/shoutout/v1',
                destPath: '/v1',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/email-marketing/v1',
                destPath: '/v1',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/shoutout-editor/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/shoutout-editor',
                destPath: '/api',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/shoutout-editor/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/shoutout-editor',
                destPath: '/api',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves sender details.
 *
 * The sender details include the information displayed as the email sender's name and email address.
 *
 * + If you send an email campaign with a public email domain (e.g. @gmail.com or @yahoo.com), the email address will not be displayed in the 'from' header. Instead, the email address is replaced with @wixemails.com (or @wixsitemail.com for free users), and the sender's email is placed in the 'reply-to' header.
 * + If you send an email campaign with an email from a Wix managed domain, that email will be displayed in the 'from' header.
 * + If you send an email from a custom domain that is not managed by Wix, a line will be inserted that states that the email was sent via wixemails.com.
 */
export function get(payload) {
    var _a = serializer(_getSenderDetailsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSenderDetailsResponse, {
        _senderDetails: _senderDetails,
    }).fromJSON;
    function __get(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.email_marketing.v1.sender_details',
            method: 'GET',
            methodFqn: 'wix.emailmarketing.api.v1.SenderDetailsService.Get',
            url: resolveWixEmailmarketingApiV1SenderDetailsServiceUrl({
                protoPath: '/v1/sender-details',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __get.fromReq = fromReq;
    __get.__isAmbassador = true;
    return __get;
}
/**
 * Updates sender details (only provided fields will be updated).
 *
 * If `from_email` is changed - a verification code will be sent to new email address.
 * If verification is needed, a verification email will be sent to the user, and `verification_needed` will return true.
 */
export function update(payload) {
    var _a = serializer(_updateSenderDetailsRequest, { _senderDetails: _senderDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSenderDetailsResponse, {}).fromJSON;
    function __update(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.email_marketing.v1.sender_details',
            method: 'PATCH',
            methodFqn: 'wix.emailmarketing.api.v1.SenderDetailsService.Update',
            url: resolveWixEmailmarketingApiV1SenderDetailsServiceUrl({
                protoPath: '/v1/sender-details',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __update.fromReq = fromReq;
    __update.__isAmbassador = true;
    return __update;
}
/** Verifies the sender's email using a verification code sent to the user's email address upon update. */
export function verifyEmail(payload) {
    var _a = serializer(_verifySenderEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_verifySenderEmailResponse, {}).fromJSON;
    function __verifyEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.email_marketing.v1.sender_details',
            method: 'POST',
            methodFqn: 'wix.emailmarketing.api.v1.SenderDetailsService.VerifyEmail',
            url: resolveWixEmailmarketingApiV1SenderDetailsServiceUrl({
                protoPath: '/v1/sender-details/verify-email',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __verifyEmail.fromReq = fromReq;
    __verifyEmail.__isAmbassador = true;
    return __verifyEmail;
}
/** Checks if the sender's email address will be used as from-address or replaced (not related to current sender details). */
export function resolveActualFromAddress(payload) {
    var _a = serializer(_resolveActualFromAddressRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resolveActualFromAddressResponse, {}).fromJSON;
    function __resolveActualFromAddress(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.email_marketing.v1.sender_details',
            method: 'POST',
            methodFqn: 'wix.emailmarketing.api.v1.SenderDetailsService.ResolveActualFromAddress',
            url: resolveWixEmailmarketingApiV1SenderDetailsServiceUrl({
                protoPath: '/v1/sender-details/actual-from-address',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resolveActualFromAddress.fromReq = fromReq;
    __resolveActualFromAddress.__isAmbassador = true;
    return __resolveActualFromAddress;
}
//# sourceMappingURL=http.impl.js.map